module.exports = {"title":"Special bonus offers ","link":"https://karamba.com/info/bonus-policy"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/bonusPolicy.json
// module id = 630
// module chunks = 247 1465